module.exports = __webpack_public_path__ + "img/Haube.60d5b349.png";